module.exports = "e63108e900d9d927d4d9a05b8fd68726.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/music/track1.mp3
// module id = 84
// module chunks = 0